import { List, ListItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { AuthContext } from 'context/auth/AuthContext';
import { Types } from 'context/auth/AuthReducer';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    sideNav: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.palette.primary.main,
        height: 'calc(100vh - 75px)',
        width: '75px',
    },
    menuItems: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 50,
        marginTop: 25,
        cursor: 'pointer',
    },
    menuItem: {
        color: 'white',
        textAlign: 'center',
        fontSize: 12,
        textDecoration: 'none',
    },
}));

const SideNavigation = () => {
    const classes = useStyles();
    const menuItems = [
        { name: 'Model manager', url: '/', icon: <AccountTreeIcon /> },
        { name: 'Gallery', url: '/gallery', icon: <DashboardIcon /> },
    ];
    const { dispatch } = useContext(AuthContext);

    const handleLogout = () => {
        dispatch({
            type: Types.Logout,
            payload: {
                isAuthenticated: false,
                user: {
                    email: '',
                    accessToken: '',
                    name: '',
                    id: '',
                },
            },
        });
    };
    return (
        <List className={classes.sideNav}>
            {menuItems.map((menuItem) => (
                <ListItem className={classes.menuItems} key={menuItem.name}>
                    <Link className={classes.menuItem} to={menuItem.url}>
                        <React.Fragment>
                            {menuItem.icon}
                            {menuItem.name}
                        </React.Fragment>
                    </Link>
                </ListItem>
            ))}
            <ListItem className={classes.menuItems} onClick={handleLogout}>
                <div className={classes.menuItem}>
                    <React.Fragment>
                        <ExitToAppIcon />
                        Logout
                    </React.Fragment>
                </div>
            </ListItem>
        </List>
    );
};

export default SideNavigation;
